module.exports = __webpack_public_path__ + "static/media/card-back.278d170a.png";